import React, { createContext, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

export const CopilotContext = createContext();

const CopilotProviderComponent = ({ companyId, children }) => {
  const iframe = useRef(null);

  const [iframeTimestamp] = useState(Date.now().toString());

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const listenToIframe = (event) => {
      if (event.origin === "https://chat-ui-dev.xion.ai" || event.origin === "http://localhost:39379") {
        const message = JSON.parse(event.data);
        if (!(message instanceof Object)) return;

        if ("isReady" in message) {
          setTimeout(() => {
            setIsReady(true);
          }, 500);
        } else if ("isOpen" in message) {
          if (message["isOpen"]) iframe.current.style.zIndex = 3000;
          else
            setTimeout(() => {
              iframe.current.style.zIndex = -1;
            }, 300);
        }
      }
    };
    window.addEventListener("message", listenToIframe);
    return () => {
      window.removeEventListener("message", listenToIframe);
    };
  }, []);

  useEffect(() => {
    if (isReady && companyId) {
      const message = JSON.stringify({ companyId });
      if (iframe.current && iframe.current.contentWindow) {
        iframe.current.contentWindow.postMessage(message, "*");
      }
    }
  }, [isReady, companyId]);

  return (
    <CopilotContext.Provider value={{ iframe, isReady }}>
      {children}
      {window.location.hostname === "vault-dev.xion.ai" || window.location.hostname === "localhost" ? (
        <iframe
          ref={iframe}
          title="copilot"
          src={`${window.location.hostname === "vault-dev.xion.ai"
            ? 'https://chat-ui-dev.xion.ai'
            : 'http://localhost:39379'}/?uuid=${iframeTimestamp}`}
          allowtransparency="true"
          style={{
            backgroundColor: "transparent",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: -1,
            border: "none",
          }}
          onLoad={() => {
            if (!isReady && iframe.current && iframe.current.contentWindow)
              iframe.current.contentWindow.postMessage(
                JSON.stringify({ isReady: true }),
                "*"
              );
          }}
        />
      ) : null}
    </CopilotContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  companyId: state.home.companyId || "",
});

export const CopilotProvider = connect(mapStateToProps)(
  CopilotProviderComponent
);
